import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
var HomeWorkRequsetComponent = (function () {
    function HomeWorkRequsetComponent(route, apiService, el, router) {
        this.route = route;
        this.apiService = apiService;
        this.el = el;
        this.router = router;
        this.selectedTag = "";
        this.placeholder = '';
        this.data = {};
        this.isIcon = false;
        this.isShowToast = false;
        this.destext = "";
        this.isShowPlaceholder = true; //是否显示placeholder
    }
    HomeWorkRequsetComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.data.relationId = queryParams['relationId'];
            _this.constituteId = queryParams['constituteId'];
            _this.tabNum = queryParams['tabNum'];
            _this.type = queryParams['type'];
            _this.comment = queryParams['comment'];
            _this.learningPathMetaId = queryParams['learningPathMetaId'];
            _this.projectId = queryParams['projectId'];
        });
    };
    HomeWorkRequsetComponent.prototype.ngAfterViewInit = function () {
        this.textarea = this.el.nativeElement.querySelector('textarea');
        if (this.comment) {
            this.textarea.value = this.comment;
        }
    };
    HomeWorkRequsetComponent.prototype.back = function () {
        if (this.type === 'comment') {
            if (this.projectId) {
                this.router.navigate(['home-work-show', this.constituteId], { queryParams: { 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, 'projectId': this.projectId } });
            }
            else if (this.learningPathMetaId) {
                this.router.navigate(['home-work-show', this.constituteId], { queryParams: { 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, 'learningPathMetaId': this.learningPathMetaId } });
            }
        }
        else {
            if (this.projectId) {
                this.router.navigate(['home-work-show', this.constituteId], { queryParams: { 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, 'projectId': this.projectId } });
            }
            else if (this.learningPathMetaId) {
                this.router.navigate(['home-work-show', this.constituteId], { queryParams: { 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, 'learningPathMetaId': this.learningPathMetaId } });
            }
            // if(this.isFirstDay){
            //     this.router.navigate(['learning-camp-response'],{queryParams:{'constituteId':this.constituteId,'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,learningPathId:this.learningPathId,courseId:this.courseId,firstDay:1}});
            // }else if(this.isLastDay){
            //     this.router.navigate(['learning-camp-response'],{queryParams:{'constituteId':this.constituteId,'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,learningPathId:this.learningPathId,courseId:this.courseId,isLastDay:1}});
            // }else{
            //     this.router.navigate(['learning-camp-response'],{queryParams:{'constituteId':this.constituteId,'tabNum':this.tabNum,relationId:this.data.relationId,comment:this.textarea.value,back:1,learningPathId:this.learningPathId,courseId:this.courseId}});
            // }
        }
    };
    //发送
    HomeWorkRequsetComponent.prototype.send = function () {
        var _this = this;
        if (!localStorage.getItem("debuonceFlag")) {
            localStorage.setItem("debuonceFlag", "1");
            setTimeout(function () {
                localStorage.removeItem("debuonceFlag");
            }, 4000);
            if (this.type === 'comment') {
                //评论 输入不能为空 可以输入空格
                if (this.textarea.value.length > 0) {
                    //掉接口.then
                    this.data.type = 'comment';
                    this.data.context = this.textarea.value;
                    this.isShowToast = false;
                    this.askQuestion(this.data).then(function () {
                        _this.textarea.value = "";
                        _this.back();
                    }).catch(function (err) {
                        if (err['error']['code'] === 101) {
                            _this.isShowToast = true;
                            _this.toastType = 2;
                            _this.destext = err['error']['msg'];
                            setTimeout(function () {
                                _this.isShowToast = false;
                            }, 1500);
                        }
                    });
                }
                else {
                    this.isShowToast = true;
                    this.destext = '字数要大于0哦~';
                    if (this.isShowToast) {
                        setTimeout(function () {
                            _this.isShowToast = false;
                        }, 2000);
                    }
                }
            }
        }
    };
    HomeWorkRequsetComponent.prototype.ngOnDestroy = function () {
        if (localStorage.getItem("debuonceFlag")) {
            localStorage.removeItem("debuonceFlag");
        }
    };
    HomeWorkRequsetComponent.prototype.textareaFocus = function () {
        this.isShowPlaceholder = false;
    };
    //textarea失去焦点触发事件
    HomeWorkRequsetComponent.prototype.textareaBlur = function () {
        this.isShowPlaceholder = this.textarea.value === "" ? true : false;
    };
    //隐藏Placeholder
    HomeWorkRequsetComponent.prototype.closePlaceholder = function () {
        this.isShowPlaceholder = false;
        this.textarea.focus();
    };
    //追问 评论
    HomeWorkRequsetComponent.prototype.askQuestion = function (data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': '/ddilearner/v2/user/project/homework/saveOperationLog',
            'data': data
        }).toPromise();
    };
    return HomeWorkRequsetComponent;
}());
export { HomeWorkRequsetComponent };



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-request/home-work-request.component.ts.pre-build-optimizer.js